import { confirmAlert } from "react-confirm-alert";

export const deleteOnConfirm = (id, onDelete, onCancel) => {
    confirmAlert({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => onDelete(id)
            },
            {
                label: 'No',
                onClick: () => onCancel
            }
        ]
    });
}

export const completeOnConfirm = (id, onSave, onCancel) => {
    confirmAlert({
        title: 'Are you sure?',
        message: 'You will not able to add Invoice Item after complete?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => onSave(id)
            },
            {
                label: 'No',
                onClick: () => onCancel
            }
        ]
    });
}

export const confirmOnCreateInvoice = (onSave, onCancel, message) => {
    confirmAlert({
        title: 'Are you sure?',
        message: `You have selected ${message} Items. Do you want to proceed?`,
        buttons: [
            {
                label: 'Yes',
                onClick: () => onSave()
            },
            {
                label: 'No',
                onClick: () => onCancel
            }
        ]
    });
}